<template>
  <div
    class="wrapper"
    :class="[{'nav-open': $sidebar.showSidebar}, {'rtl': $route.meta.rtlActive}]"
  >
    <ChangePassword />
    <notifications />
    
    <div class="layout-flex-container">
      <div 
        class="sidebar-layout-container"
        :class="{ 'is-sidebar-collapsed': !$sidebar.showSidebar }"
      >
        <side-bar 
          :is-collapsed="!$sidebar.showSidebar"
          @toggle="handleSidebarToggle"
        >      
          <mobile-menu></mobile-menu>
          <template slot-scope="props" slot="links">
            <sidebar-item :link="{name: 'Dashboard', icon: DashboardIcon, path: '/dashboard'}"></sidebar-item>
            <sidebar-item :link="{name: 'Revenue Dashboard', icon: RevenueDashoardIcon, path: '/revenue-dashboard'}"></sidebar-item>
            
            <sidebar-item 
              v-if="$constants.userCan(['payebill.getpayrollpayeestimates'])" 
              :link="{name: 'PAYE Estimate', icon: PayeEstimatesIcon, path: '/payroll-paye-estimate'}"
            ></sidebar-item>
            <sidebar-item :link="{name: 'Tax Payers', icon: TaxpayersIcon}">
              <sidebar-item
                v-if="$constants.userCan(['taxpayer.getall'])"
                :link="{name: 'Individual Payers', path: '/tax-payers/individual', icon: ProfileIcon}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.userCan(['taxpayer.getall'])"
                :link="{name: 'Individual Payers(Unactivated)', path: '/tax-payers/individual/unactivated', icon: TaxpayersUnactivatedIcon}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.userCan(['taxpayer.getall'])"
                :link="{name: 'Bulk Individual Registrations', path: '/tax-payers/bulk-individual-registrations', icon: UserGroupIcon}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.userCan(['taxpayer.getall'])"
                :link="{name: 'Corporate Payers', path: '/tax-payers/corporate', icon: CorporateTaxpayersIcon}"
              ></sidebar-item>
              <sidebar-item
                 v-if="$constants.userCan(['taxpayer.getall'])"
                 :link="{name: 'Corporate Payers(Unactivated)', path: '/tax-payers/corporate/unactivated', icon: CorporateTaxpayersUnactivatedIcon}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.userCan(['taxpayer.getone'])"
                :link="{name: 'Tax Payer Verification', path: '/tax-payers/verification', icon: TaxpayersVerificationIcon}"
              ></sidebar-item>
              <sidebar-item
              v-if="$constants.userCan(['taxpayerstatusrequest.getall'])"
              :link="{name: 'Status Request', icon: StatusRequestIcon , path: '/taxpayer-status-requests'}"
          ></sidebar-item>
            </sidebar-item>

            <sidebar-item :link="{name: 'Tax Services', icon: TaxServicesIcon, path: '/tax-services'}"></sidebar-item>
            <sidebar-item :link="{name: 'Tax Offices', icon: TaxOfficesIcon, path: '/tax-offices'}"></sidebar-item>
            <sidebar-item :link="{name: 'Merge Requests', icon: AccountsMergeIcon, path: '/merge-requests'}"></sidebar-item>
            <sidebar-item :link="{name: 'Address Change Requests', icon: AddressChangeRequestsIcon, path: '/address-change-requests'}"></sidebar-item>
            <sidebar-item :link="{name: 'Tama Registration', icon: TamaRegistrationIcon, path: '/tama-requests'}"></sidebar-item>
            
            <sidebar-item
              :link="{name: 'Consultants', icon: ConsultantsIcon, path: '/consultants'}"
              v-if="$constants.hasNestedAccess(['consultant.getallconsultants', 'tax_payer_manager'])"
            ></sidebar-item>
            <sidebar-item
              :link="{name: 'Consultants (TAMA)', icon: ConsultantsTamaIcon, path: '/consultants-tama'}"
              v-if="$constants.hasNestedAccess(['consultant.getallconsultants', 'tax_audit'])"
            ></sidebar-item>
            <sidebar-item
              :link="{name: 'TAMA Job Requests', icon: TamaJobRequestsIcon, path: '/consultants-tama-job-requests'}"
              v-if="$constants.hasNestedAccess(['consultant.getallconsultants', 'tax_audit'])"
            ></sidebar-item>
            <sidebar-item v-if="!isAdminOfficeHnw" :link="{name: 'RMU', icon: RmuIcon}">
              <sidebar-item
                :link="{name: 'RMU', icon: RmuIcon, path: '/relationship-management-unit'}"
                v-if="$constants.userCan(['consultant.getallconsultants'])"
              ></sidebar-item>
              <sidebar-item
                :link="{name: 'RMU Revenue', path: '/reports/rmu-revenue', icon: RmuRevenueIcon}"
              ></sidebar-item>
            </sidebar-item>
            <sidebar-item
              :link="{name: 'High Networth', icon: HighNetworthIcon, path: '/high-net-worth'}"
              v-if="$constants.userCan(['taxpayer.can_see_hnw'])"
            ></sidebar-item>
            <sidebar-item
              v-if="$constants.userCan(['tcc.getall'])"
              :link="{name: 'TCC', icon: TccIcon, path: '/tcc/certificates'}"
            ></sidebar-item>
            <sidebar-item
              :link="{name: 'Payments', icon: PaymentsIcon, path: '/payments'}"
              v-if="$constants.userCan(['bill.create', 'bill.generate'])"
            ></sidebar-item>
            <sidebar-item
              :link="{name: 'My Audit Cases', icon: 'assessment', path: '/my-audit-cases'}"
              v-if="isTamaUser()"
            ></sidebar-item>
            <sidebar-item :link="{name: 'Tax Audits', icon: CalculatorIcon}">
              <sidebar-item
                v-if="$constants.hasNestedAccess(['taxaudit.getall', 'default'])"
                :link="{name: 'Cases', icon: CasesIcon, path: '/tax-audits-cases'}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.hasNestedAccess(['taxaudit.getall', 'assigned'])"
                :link="{name: 'Assigned Cases', icon: AssignedCasesIcon, path: '/assigned-audit-cases'}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.userCan(['taxaudit.getallteams'])"
                :link="{name: 'Team Allocation', icon: TeamAllocationIcon, path: '/tax-audits-team'}"
              ></sidebar-item>
              <sidebar-item
                v-if="isSuperAdminUser()"
                :link="{name: 'Team Overview', icon: TeamOverviewIcon, path: '/tax-audits-team-overview'}"
              ></sidebar-item>
            </sidebar-item>

            <sidebar-item :link="{name: 'Objections', icon: ObjectionsIcon}">
              <sidebar-item :link="{name: 'Objection Cases', icon: ObjectionsIcon}">
                <sidebar-item
                  :link="{name: 'Assessment', path: '/objections/assessment', icon: TaxpayersIcon}"
                ></sidebar-item>
                <sidebar-item
                  :link="{name: 'Tax Audit', path: '/objections/tax-audit', icon: CorporateTaxpayersIcon}"
                ></sidebar-item>
              </sidebar-item>
              <sidebar-item
                v-if="$constants.hasNestedAccess(['taxaudit.getall', 'default'])"
                :link="{name: 'Legal', icon: LegalIcon, path: '/flagged-objections'}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.hasNestedAccess(['taxaudit.getall', 'assigned'])"
                :link="{name: 'Assigned Objections', icon: AssignedObjectionsIcon, path: '/assigned-objections'}"
              ></sidebar-item>
            </sidebar-item>

            <sidebar-item :link="{name: 'LASPPPA', icon: LaspppaIcon, path: '/laspppa/requests'}"></sidebar-item>

            <sidebar-item v-if="$constants.userCan(['report.getreport'])" :link="{name: 'Reports', icon: ReportsIcon}">
              <sidebar-item :link="{name: 'Directors', path: '/reports/directors', icon: DirectorsIcon}"></sidebar-item>
              <sidebar-item :link="{name: 'Debts', path: '/reports/debts', icon: NairaIcon}"></sidebar-item>

              <template v-if="isAdminOfficeHnw">
                <sidebar-item :link="{name: 'Tax Payers', path: '/reports/individual-tax-payers', icon: TaxpayersIcon}"></sidebar-item>
                <sidebar-item :link="{name: 'Returns', path: '/reports/individual-returns', icon: ReturnsIcon}"></sidebar-item>
                <sidebar-item :link="{name: 'Assessments', path: '/reports/individual-assessments', icon: AssessmentsListIcon}"></sidebar-item>
              </template>
              <template v-else>
                <sidebar-item :link="{name: 'Tax Payers', icon: TaxpayersIcon}">
                  <sidebar-item :link="{name: 'Individual', path: '/reports/individual-tax-payers', icon: ProfileIcon}"></sidebar-item>
                  <sidebar-item :link="{name: 'Corporate', path: '/reports/corporate-tax-payers', icon: CorporateTaxpayersIcon}"></sidebar-item>
                </sidebar-item>
                
                <sidebar-item :link="{name: 'Returns', icon: ReturnsIcon}">
                  <sidebar-item :link="{name: 'Individual', path: '/reports/individual-returns', icon: TaxpayersIcon}"></sidebar-item>
                  <sidebar-item v-if="!isAdminOfficeHnw" :link="{name: 'Corporate', path: '/reports/corporate-returns', icon: CorporateTaxpayersIcon}"></sidebar-item>
                  <sidebar-item v-if="!isAdminOfficeHnw" :link="{name: 'HORC', path: '/reports/corporate-horc-returns', icon: HorcIcon}"></sidebar-item>
                  <sidebar-item v-if="!isAdminOfficeHnw" :link="{name: 'Adequacy Checks', path: '/reports/adequacy-checks', icon: AdequacyChecksIcon}"></sidebar-item>
                </sidebar-item>
                
                <sidebar-item :link="{name: 'Assessments', icon: AssessmentsListIcon}">
                  <sidebar-item :link="{name: 'Individual', path: '/reports/individual-assessments', icon: TaxpayersIcon}"></sidebar-item>
                  <sidebar-item v-if="!isAdminOfficeHnw" :link="{name: 'Corporate', path: '/reports/corporate-assessments', icon: CorporateTaxpayersIcon}"></sidebar-item>
                </sidebar-item>
                
                <sidebar-item :link="{name: 'Objections', path: '/reports/objections', icon: ObjectionsIcon}"></sidebar-item>
              </template>

              <sidebar-item
                :link="{name: 'Tax Audit', path: '/reports/tax-audit', icon: CalculatorIcon}"
                v-if="$constants.userCan(['assessment.getallassessmentgroups'])"
              ></sidebar-item>
              <sidebar-item :link="{name: 'Revenue', path: '/reports/revenue', icon: RevenueIcon}"></sidebar-item>
              <sidebar-item :link="{name: 'Bills', path: '/reports/bills', icon: BillsIcon}"></sidebar-item>
            </sidebar-item>

            <sidebar-item v-if="$constants.userCan(['report.getreport'])" :link="{name: 'EBS Reports', icon: EbsReportsIcon}">
              <sidebar-item :link="{name: 'Transactions', icon: TransactionsIcon, path: '/ebs-reports/transactions'}"></sidebar-item>
              <sidebar-item :link="{name: 'Expatriates', icon: UserGroupIcon, path: '/ebs-reports/expatriates'}"></sidebar-item>
              <sidebar-item :link="{name: 'Trend Collection', icon: TrendCollectionIcon, path: '/ebs-reports/trends'}"></sidebar-item>
            </sidebar-item>

            <sidebar-item :link="{name: 'Assessment Requests', icon: AssessmentsListIcon, path: '/assessment-modification-requests'}"></sidebar-item>
            <sidebar-item :link="{name: 'EGIS', icon: EgisIcon, path: '/egis-geo-tagging'}"></sidebar-item>

            <sidebar-item :link="{name: 'Messages', icon: MessagesIcon}">
              <sidebar-item :link="{name: 'Direct Messages', icon: DirectMessagesIcon, path: '/messages/direct'}"></sidebar-item>
              <sidebar-item v-if="$constants.userCan(['admin.getall'])" :link="{name: 'Bulk Messages', icon: BulkMessagesIcon, path: '/messages/bulk'}"></sidebar-item>
            </sidebar-item>

            <sidebar-item :link="{name: 'Admin Hub', icon: SettingsIcon }">
              <sidebar-item
                :link="{name: 'Admin Tools', icon: AdminToolsIcon, path: '/admin-tools'}"
                v-if="$constants.userCan(['setting.getallsettings'])"
              ></sidebar-item>
              <sidebar-item
                :link="{name: 'User Management', icon: UserManagementIcon, path: '/users/all'}"
                v-if="$constants.userCan(['admin.getall'])"
              ></sidebar-item>
              <sidebar-item
                :link="{name: 'Role Management', icon: RoleManagementIcon, path: '/roles'}"
                v-if="$constants.userCan(['role.getall'])"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.userCan(['audit.getall'])" 
                :link="{name: 'Audit Trail', icon: EyeIcon, path: '/audit-trail'}"
              ></sidebar-item>
              <sidebar-item
                v-if="$constants.hasNestedAccess(['fe.taxpayer', 'advancedupdate'])"
                :link="{name: 'Advanced Payer Update', path: '/tax-payers/advanced', icon: AdvancedPayerUpdateIcon}"
              ></sidebar-item>
            </sidebar-item>

            <li class="custom-nav-item">
              <a class="nav-link-custom" href="/template-docs/Admin_Etax_End_User_Guide_Tax_Officer.pdf" download>
                 <DownloadManualIcon class="nav-icon" />
                <p v-if="$sidebar.showSidebar || props.isHovered" class="nav-text-inline">Download Manual</p>
              </a>
            </li>
          </template>
        </side-bar>
      </div>

      <div class="main-panel">
        <top-navbar></top-navbar>

        <template v-if="recaptchaValid">
          <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
            <zoom-center-transition :duration="200" mode="out-in">
              <router-view></router-view>
            </zoom-center-transition>
          </div>
        </template>
        <template v-else-if="!recaptchaValid && showRecaptcha">
          <user-validation @verified="recaptchaValid = true" />
        </template>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePassword from "@/lib/ChangePassword";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";
import { isSubAdmin, isSuperAdmin, isTamaAdmin, isHNWOffice} from "@/lib/utils";
import UserValidation from "@/components/UserValidation.vue";
import DashboardIcon from "@/components/Icons/SidebarIcons/dashboard-icon.vue";
import RevenueDashoardIcon from "@/components/Icons/SidebarIcons/revenue-dashboard-icon.vue";
import PayeEstimatesIcon from "@/components/Icons/SidebarIcons/paye-estimates-icon.vue";
import TaxpayersIcon from "@/components/Icons/SidebarIcons/taxpayers-icon.vue";
import TaxServicesIcon from "@/components/Icons/SidebarIcons/tax-services-icon.vue";
import ProfileIcon from "@/components/Icons/SidebarIcons/profile-icon.vue";
import TaxpayersUnactivatedIcon from "@/components/Icons/SidebarIcons/taxpayers-unactivated-icon.vue";
import UserGroupIcon from "@/components/Icons/SidebarIcons/user-group-icon.vue";
import CorporateTaxpayersIcon from "@/components/Icons/SidebarIcons/corporate-taxpayers-icon.vue";
import CorporateTaxpayersUnactivatedIcon from "@/components/Icons/SidebarIcons/corporate-taxpayers-unactivated-icon.vue";
import TaxpayersVerificationIcon from "@/components/Icons/SidebarIcons/taxpayers-verification-icon.vue";
import TaxOfficesIcon from "@/components/Icons/SidebarIcons/tax-offices-icon.vue";
import AccountsMergeIcon from "@/components/Icons/SidebarIcons/accounts-merge-icon.vue";
import AddressChangeRequestsIcon from "@/components/Icons/SidebarIcons/address-change-requests-icon.vue";
import TamaRegistrationIcon from "@/components/Icons/SidebarIcons/tama-registration-icon.vue";
import ConsultantsIcon from "@/components/Icons/SidebarIcons/consultants-icon.vue";
import ConsultantsTamaIcon from "@/components/Icons/SidebarIcons/consultants-tama-icon.vue";
import TamaJobRequestsIcon from "@/components/Icons/SidebarIcons/tama-job-requests-icon.vue";
import RmuIcon from "@/components/Icons/SidebarIcons/rmu-icon.vue";
import RmuRevenueIcon from "@/components/Icons/SidebarIcons/rmu-revenue-icon.vue";
import HighNetworthIcon from "../../../components/Icons/SidebarIcons/high-networth-icon.vue";
import TccIcon from "@/components/Icons/SidebarIcons/tcc-icon.vue";
import PaymentsIcon from "@/components/Icons/SidebarIcons/payments-icon.vue";
import CalculatorIcon from "@/components/Icons/SidebarIcons/calculator-icon.vue";
import ObjectionsIcon from "@/components/Icons/SidebarIcons/objections-icon.vue";
import ReportsIcon from "@/components/Icons/SidebarIcons/reports-icon.vue";
import CasesIcon from "@/components/Icons/SidebarIcons/cases-icon.vue";
import AssignedCasesIcon from "@/components/Icons/SidebarIcons/assigned-cases-icon.vue";
import TeamAllocationIcon from "@/components/Icons/SidebarIcons/team-allocation-icon.vue";
import TeamOverviewIcon from "@/components/Icons/SidebarIcons/team-overview-icon.vue";
import LegalIcon from "@/components/Icons/SidebarIcons/legal-icon.vue";
import LaspppaIcon from "@/components/Icons/SidebarIcons/laspppa-icon.vue";
import AssignedObjectionsIcon from "@/components/Icons/SidebarIcons/assigned-objections-icon.vue";
import DirectorsIcon from "@/components/Icons/SidebarIcons/directors-icon.vue";
import NairaIcon from "@/components/Icons/SidebarIcons/naira-icon.vue";
import ReturnsIcon from "@/components/Icons/SidebarIcons/returns-icon.vue";
import AssessmentsListIcon from "@/components/Icons/SidebarIcons/assessments-list-icon.vue";
import HorcIcon from "@/components/Icons/SidebarIcons/horc-icon.vue";
import AdequacyChecksIcon from "@/components/Icons/SidebarIcons/adequacy-checks-icon.vue";
import RevenueIcon from "@/components/Icons/SidebarIcons/revenue-icon.vue";
import BillsIcon from "@/components/Icons/SidebarIcons/bills-icon.vue";
import EbsReportsIcon from "@/components/Icons/SidebarIcons/ebs-reports-icon.vue";
import TransactionsIcon from "@/components/Icons/SidebarIcons/transactions-icon.vue";
import TrendCollectionIcon from "@/components/Icons/SidebarIcons/trend-collection-icon.vue";
import EgisIcon from "@/components/Icons/SidebarIcons/egis-icon.vue";
import MessagesIcon from "@/components/Icons/SidebarIcons/messages-icon.vue";
import DirectMessagesIcon from "@/components/Icons/SidebarIcons/direct-messages-icon.vue";
import BulkMessagesIcon from "@/components/Icons/SidebarIcons/bulk-messages-icon.vue";
import SettingsIcon from "@/components/Icons/SidebarIcons/settings-icon.vue";
import AdminToolsIcon from "@/components/Icons/SidebarIcons/admin-tools-icon.vue";
import UserManagementIcon from "@/components/Icons/SidebarIcons/user-management-icon.vue";
import RoleManagementIcon from "@/components/Icons/SidebarIcons/role-management-icon.vue";
import EyeIcon from "@/components/Icons/SidebarIcons/eye-icon.vue";
import AdvancedPayerUpdateIcon from "@/components/Icons/SidebarIcons/advanced-payer-update-icon.vue";
import DownloadManualIcon from "@/components/Icons/SidebarIcons/download-manual-icon.vue";
import StatusRequestIcon from "@/components/Icons/SidebarIcons/status-request-icon.vue";

export default {
  components: {
    UserValidation,
    ChangePassword,
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
    SlideYDownTransition,
    ZoomCenterTransition,
    DownloadManualIcon
  },
  data() {
    return {
      StatusRequestIcon,
      DashboardIcon,
      RevenueDashoardIcon,
      PayeEstimatesIcon,
      TaxpayersIcon,
      TaxServicesIcon,
      ProfileIcon,
      TaxpayersUnactivatedIcon,
      UserGroupIcon,
      CorporateTaxpayersIcon,
      CorporateTaxpayersUnactivatedIcon,
      TaxpayersVerificationIcon,
      TaxOfficesIcon,
      AccountsMergeIcon,
      AddressChangeRequestsIcon,
      TamaRegistrationIcon,
      ConsultantsIcon,
      ConsultantsTamaIcon,
      TamaJobRequestsIcon,
      RmuIcon,
      RmuRevenueIcon,
      HighNetworthIcon,
      TccIcon,
      PaymentsIcon,
      CalculatorIcon,
      ObjectionsIcon,
      CasesIcon,
      AssignedCasesIcon,
      TeamAllocationIcon,
      TeamOverviewIcon,
      LegalIcon,
      LaspppaIcon,
      AssignedObjectionsIcon,
      ReportsIcon,
      DirectorsIcon,
      NairaIcon,
      ReturnsIcon,
      AssessmentsListIcon,
      HorcIcon,
      AdequacyChecksIcon,
      RevenueIcon,
      BillsIcon,
      EbsReportsIcon,
      TransactionsIcon,
      TrendCollectionIcon,
      EgisIcon,
      MessagesIcon,
      DirectMessagesIcon,
      BulkMessagesIcon,
      SettingsIcon,
      AdminToolsIcon,
      UserManagementIcon,
      RoleManagementIcon,
      EyeIcon,
      AdvancedPayerUpdateIcon,
      showRecaptcha: false,
      recaptchaValid: true
    }
  },
  computed: {
    isAdminOfficeHnw() {
      return isHNWOffice();
    }
  },
  methods: {
    handleSidebarToggle(collapsedState) {
      this.$sidebar.displaySidebar(!collapsedState);
    },
    async logoutUser() {
      await this.$logout(this);
    },
    isSubAdminUser() {
      return isSubAdmin();
    },

    isSuperAdminUser() {
      return isSuperAdmin();
    },

    isTamaUser() {
      return isTamaAdmin();
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar && window.innerWidth <= 991) {
        this.$sidebar.displaySidebar(false);
      }
    },

    checkRecaptcha() {
      const { meta } = this.$route;
      if (meta && meta.requestCaptcha) {
        this.showRecaptcha = true
      } else {
        this.recaptchaValid = true
      }
    },
  },

  mounted() {
    // this.checkRecaptcha();
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
  display: flex;
}

.layout-flex-container {
  display: flex;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  position: relative;
}

.sidebar-layout-container {
  width: 287px;
  height: 100vh;
  flex-shrink: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-layout-container.is-sidebar-collapsed {
  width: 80px;
}

@media (max-width: 991px) {
  .sidebar-layout-container {
    width: 0 !important;
  }
}

.layout-flex-container > .sidebar-layout-container side-bar {
  height: 100vh;
  overflow-y: auto;
  flex-shrink: 0;
}

.main-panel {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  
  &::after {
    display: block;
    content: "";
    clear: both;
  }
}

.content {
  flex: 1 0 auto;
}

@media (max-width: 991px) {
  .wrapper {
    overflow-x: hidden;
  }
  
  .main-panel {
    width: 100%;
    max-width: 100%;
  }
}

$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>

<style lang="scss">
.selfLink-2 {
  margin-left: -10px;
  color: #ffffff !important;
}
.selfLink-2 a {
  padding-left: 28px;
  padding-top: 20px;
  font-size: 13px;
  margin-right: -10px;
  color: #ffffff !important;
}
.sidebar .nav li a, .off-canvas-sidebar .nav li a {
  color: #ffffff !important;
}
</style>